var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcChargers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3195 20.0142C10.6077 20.7046 9.99451 21.5845 9.49615 22.3321L7 20.6679C7.50164 19.9155 8.26731 18.7954 9.2307 17.8608C10.1722 16.9475 11.5178 16 13.1912 16C15.3017 16 16.4173 17.5514 17.057 18.4411C17.1009 18.5021 17.1426 18.5601 17.1822 18.6142C17.932 19.6389 18.3089 20 19.0448 20C19.7417 20 20.4724 19.6248 21.2266 18.9107C21.9689 18.2079 22.5648 17.3369 22.9906 16.6822L25.5055 18.3178C25.0642 18.9964 24.3072 20.1254 23.2891 21.0893C22.2829 22.0419 20.8455 23 19.0448 23C16.6737 23 15.4896 21.3815 14.7745 20.4041L14.7611 20.3858C13.9141 19.2282 13.6675 19 13.1912 19C12.6791 19 12.0532 19.3025 11.3195 20.0142Z",
    fill: "#FFC20E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.248 13H8.24805V10H24.248V13Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcChargers);
export default __webpack_public_path__ + "static/media/ac_chargers.a96f32a7979ed8c8e17c3eda75b224aa.svg";
export { ForwardRef as ReactComponent };